import BaseService from './BaseService'
import config from '../config'
import moment from 'moment-timezone'
class WorkflowsResellingService extends BaseService {
  PRODUCT_ID = 'starter_plus_workflow_premium_actions_triggers'
  BLACK_FRIDAY_PRODUCT_ID = 'workflow_pro_black_friday'

  constructor(baseUrl: string) {
    super(baseUrl)
  }

  get isBlackFriday() {
    // Define the start and end dates in PST timezone
    const startDateString = config.mode === 'production' ? '2024-12-20' : '2024-12-16'
    const startDate = moment.tz(startDateString, 'America/Los_Angeles').startOf('day')
    const endDate = moment.tz('2024-12-31', 'America/Los_Angeles').endOf('day')

    // Get the current date in PST timezone
    const currentDate = moment.tz('America/Los_Angeles')

    // Check if current date is between start and end dates
    return currentDate.isBetween(startDate, endDate, null, '[]')
  }

  get productId() {
    return this.isBlackFriday ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID
  }

  get allProductIds() {
    return [this.PRODUCT_ID, this.BLACK_FRIDAY_PRODUCT_ID]
  }

  getProductConfiguration = (isBlackFridayEnabled: boolean = false) =>
    this.requests.get(`/product?productCode=${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`)

  getCompanyResellingConfig = (companyId: string, isBlackFridayEnabled: boolean = false) =>
    this.requests.get(
      `/configuration/company/${companyId}/${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`
    )

  updateCompanyResellingConfig = (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] },
    isBlackFridayEnabled: boolean = false
  ) =>
    this.requests.put(
      `/configuration/company/${companyId}/${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`,
      data
    )

  updateCompanyResellingConfigBlackFriday = (
    companyId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] }
  ) => this.requests.put(`/configuration/company/${companyId}/${this.BLACK_FRIDAY_PRODUCT_ID}`, data)

  getLocationConfig = (locationId: string, isBlackFridayEnabled: boolean = false) =>
    this.requests.get(
      `/configuration/location/${locationId}/${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`
    )

  getLocationSubscriptions = (locationId: string) =>
    this.requests.get(`/subscription/location/${locationId}?paymentStatus=COMPLETE`)

  updateLocationResellingConfig = (
    locationId: string,
    data: { amount?: number; offeringEnabled?: boolean; plans?: { planId: string; amount: number }[] },
    isBlackFridayEnabled: boolean = false
  ) =>
    this.requests.put(
      `/configuration/location/${locationId}/${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`,
      data
    )

  agencyDirectPurchase = (locationId: string, planId: string, isBlackFridayEnabled: boolean = false) =>
    this.requests.post(
      `/subscription/location/${locationId}/${isBlackFridayEnabled ? this.BLACK_FRIDAY_PRODUCT_ID : this.PRODUCT_ID}`,
      {
        purchaseStyle: 'COMPANY_DIRECT_PURCHASE',
        planId,
      }
    )

  getCompanySubscriptions = (companyId: string) => this.requests.get(`/subscription/company/${companyId}`)
}

const instance = new WorkflowsResellingService(BaseService.servicesConfig.Reselling as string)

export default instance
